import React, { useState, useEffect, useRef } from "react";
import { useSwipeable } from 'react-swipeable';
import "scroll-behavior-polyfill";
import ProjectTile from "components/ProjectTile";
import works from '../data/works';
import arrow from "img/icons/arrow.svg";
import { motion, useAnimate } from "motion/react";

const ProjectSlider = ({workRef, appState, vH, vW, setMainPortfolio, mainPortfolio, currentProject: loadedProject}) => {

  const handlers = useSwipeable({
    onSwipedLeft: () => handleNext(),
    onSwipedRight: () => handlePrev(),
    preventDefaultTouchmoveEvent: true,
    trackMouse: false,
    delta: 50
  });

  const [scope, animate] = useAnimate();

  const [currentWork, setCurrentWork] = useState(1);
  const [orderedWorks, setOrderedWorks] = useState([]);
  const currentWorkRef = useRef(currentWork);
  const expandedRef = useRef(null);
  const [portfolioSwitchQueued, setPortfolioSwitchQueued] = useState(false);
  const [reachedEnd, setReachedEnd] = useState(false);

  const orderedWorksRef = useRef(null);
  const portfolioSwitchPendingRef = useRef(false);

  useEffect(() => {
    currentWorkRef.current = currentWork;
  }, [currentWork]);

  useEffect(() => {
    const ordered = works.filter(work => work.def === mainPortfolio).sort((a, b) => (a.order > b.order) ? 1 : -1);
    setOrderedWorks(ordered);
    orderedWorksRef.current = ordered;
  }, [mainPortfolio]);

  useEffect(() => {
    //handles setting work position in the case of a refresh or first load on a focus
    if (!loadedProject) return;

    const ind = orderedWorks.findIndex(d => d.slug === loadedProject);
    if (ind === -1) return;

    setCurrentWork(ind + 1);

  }, [loadedProject]);

  useEffect(() => {

    const handleKeyPress = (e) => {
      console.log(e);
      
      if (e.key === "ArrowRight") handleNext();
      else if (e.key === "ArrowLeft") handlePrev();
    }

    document.addEventListener('keydown', handleKeyPress);

    return () => {
      document.removeEventListener('keydown', handleKeyPress);
    }
  }, []);

  useEffect(() => {
    if (portfolioSwitchQueued || portfolioSwitchPendingRef.current) return;
    //position project slideshow
    animate(scope.current, {x: (currentWork - 1) * ((vW * 1)) * -1}, {duration: 0.3});
  }, [currentWork, vW]);

  const handlePrev = () => {
    if (portfolioSwitchQueued || portfolioSwitchPendingRef.current) return;
    console.log('prev');
    if (currentWorkRef.current > 1) {
      setCurrentWork(currentWorkRef.current - 1);
    }
  }
  const handleNext = () => {
    if (portfolioSwitchQueued || portfolioSwitchPendingRef.current) return;
    console.log('next');
    if (currentWorkRef.current + 1 === orderedWorksRef.current.length) setReachedEnd(true);
    if (currentWorkRef.current < orderedWorksRef.current.length) {
      setCurrentWork(currentWorkRef.current + 1);
    }
  }

  const handleSwitchPortfolio = () => {
    animate(scope.current, {x: 0}, {type: "tween", ease: 'linear', duration: 0.001, onComplete: () => {
      setCurrentWork(1);
      setMainPortfolio(!mainPortfolio);
      setPortfolioSwitchQueued(false);
    }});
  }

  const handleQueuePortfolioSwitch = () => {
    setPortfolioSwitchQueued(true);
  }

  const queued = portfolioSwitchQueued;

  return (
    <section className="projects">
      <div className="expanded-project-image" ref={expandedRef} />
      <div {...handlers} className="projects-row-container">
        <motion.section className="projects-row" ref={scope}>
          {orderedWorks.map((work, i) =>
            <ProjectTile
              key={work.slug}
              i={i}
              workLength={orderedWorks.length}
              workRef={workRef}
              data={work}
              workPos={currentWork}
              vW={vW}
              vH={vH}
              mainPortfolio={mainPortfolio}
              handleSwitchPortfolio={handleSwitchPortfolio}
              portfolioSwitchQueued={portfolioSwitchQueued}
              portfolioSwitchPendingRef={portfolioSwitchPendingRef}
              expandedRef={expandedRef}
            />
          )}
        </motion.section>
        <div className="project-head">
          <nav className="project-nav">
            <button
              className="icon round"
              onClick={handlePrev}
              aria-disabled={!(currentWork > 1) || queued}
            >
              <img 
                className={(!(currentWork > 1) || queued) ? "disabled" : ""} 
                src={arrow} 
                alt="left arrow"
              />
            </button>
            
            <button
              className="icon round"
              onClick={handleNext}
              aria-disabled={!(currentWork < orderedWorks.length) || queued}
            >
              <img 
                className={(!(currentWork < orderedWorks.length) || queued) ? "disabled" : ""} 
                src={arrow} 
                alt="right arrow"
              />
            </button>

            {reachedEnd &&
              <button className="outline" onClick={handleQueuePortfolioSwitch}>
                <h3>{!mainPortfolio ? "Professional" : "Personal"}</h3>
              </button>
            }
          </nav>
        </div>
      </div>
    </section>
  )
}

export default ProjectSlider;